import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
  },
  boxText: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
  box: {
    minHeight: '30px',
    maxHeight: '30px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },
  flexBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  button: {
    height: 22,
    whiteSpace: 'nowrap',
  },
  text: {
    minWidth: 50,
    maxWidth: 400,
    width: '100%',
    whiteSpace: 'normal',
  },
  textBox: {
    minWidth: 50,
    maxWidth: 400,
    width: '100%',
    height: 30,
  },
  autocomplete: {
    height: 50,
    minWidth: 50,
    maxWidth: 400,
    width: '100%',
  },
  select: {
    minWidth: 50,
    maxWidth: 400,
    width: '100%',
    textOverflow: 'ellipsis',
    height: 30,
  },
  unSelected: {
    color: theme.palette.grey[500],
  },
  checkbox: {
    height: 10,
  },
  searchBox: {
    display: 'flex',
    width: '100%',
    maxWidth: '400px',
    columnGap: '20px',
  },
  tableContainer: {
    overflowY: 'hidden',
    height: '500px',
  },
  revokeButton:{
      padding: '0.3rem 1rem',
      fontSize: '12px',
  },
  inButtonIcon: {
    marginLeft: theme.spacing(1),
  },
}));

export default useStyles;
